export default "__VITE_ASSET__OvcysSmL__"